import moment from 'moment'

const DateUtils = {
  convertUTCToLocalTime: (utcStr) => {
    return moment.parseZone(utcStr).toDate().toLocaleTimeString()
  },
  convertUTCToLocalDate: (utcStr) => {
    return moment.parseZone(utcStr).toDate().toLocaleDateString()
  },
  convertUTCToLocalDateTime: (utcStr) => {
    return moment.parseZone(utcStr).local().format('YYYY/MM/DD, HH:mm:ss')
  },
  convertUTCToLocalDateV2: (utcStr) => {
    return moment.parseZone(utcStr).local().format('YYYY/MM/DD')
  }
}
export default DateUtils



// WEBPACK FOOTER //
// ./src/utils/DateUtils.js